module.exports = __webpack_public_path__ + "img/prestador.f26b16f9.png";